import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

import { useNavigate } from "react-router-dom";

import NestedList from "./NestedList";

import { useState } from "react";
import { Link, Outlet } from "react-router-dom";

import { UserContext } from "../../contexts/user";
import { useContext } from "react";
import { Button } from "@mui/material";

import axios from "axios";

const drawerWidth = 240;

//shouldForwardProp: ()
const AppBar = styled(MuiAppBar, {
  //make a MUIAppBar using the "styled" theme
  shouldForwardProp: (prop) => prop !== "open", //When you render this AppBar element on the DOM, don't treat 'open' as a property of that element, instead use it for styling as follows
})(({ theme, open }) => ({
  //take that open prop that's been forwarded, as well as theme
  zIndex: theme.zIndex.drawer + 1, //always apply this style
  transition: theme.transitions.create(["width", "margin"], {
    //always apply this style
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    //if open is true then apply the following styles
    marginLeft: drawerWidth, //move it over so there's room for the open drawer
    width: `calc(100% - ${drawerWidth}px)`, //make it shorter
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen, //swoosh takes a different amount of time?
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(
  //see above
  ({ theme, open }) => ({
    //take theme and open
    "& .MuiDrawer-paper": {
      //edit the Paper component of the drawer (must be an object of other properties?)
      position: "relative",
      whiteSpace: "nowrap",
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: "border-box",
      ...(!open && {
        overflowX: "hidden", //no need for a horizontal scroll when it's closed
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up("sm")]: {
          width: theme.spacing(9),
        },
      }),
    },
  })
);

function TopBar({ open, setOpen }) {
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setOpen(!open);
  };
  const { user, setUser } = useContext(UserContext);

  const handleLogout = () => {
    setUser({
      username: "",
      name: "",
    });
    axios.get(`/logout`);
  };

    
      

  return (
    <AppBar id="b" position="absolute" open={open}>
      <Toolbar
        id="c"
        sx={{
          pr: "24px", // keep right padding when drawer closed
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: "36px",
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        >
           <Link to="/ManageMFA">
          {user.username}
        </Link>
          
        </Typography>
        <Link to="">
          <Button onClick={handleLogout}>Log out</Button>
        </Link>
        <IconButton color="inherit">
          <LightbulbIcon />
        </IconButton>

        <IconButton color="inherit">
          <Badge badgeContent={4} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

function LeftBar({ open, setOpen }) {
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <Drawer
      id="d"
      variant="permanent"
      open={open}
      sx={{ height: "100vh", overflowY: "auto" }}
    >
      <Toolbar
        id="e"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: [1],
        }}
      >
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      <NestedList />
    </Drawer>
  );
}

function ContentArea() {
  return (
    <Box
      id="f"
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[800],
        flexGrow: 1,
        height: "100vh",
        overflow: "auto",
      }}
    >
      <Toolbar id="g" />
    </Box>
  );
}

function NavElementsLayout() {
  const [open, setOpen] = useState(true);
  return (
    <>
      <TopBar open={open} setOpen={setOpen} />
      <LeftBar open={open} setOpen={setOpen} />

      <Outlet />
    </>
  );
}

export { TopBar, LeftBar, ContentArea, NavElementsLayout };
